import { render, staticRenderFns } from "./card5.vue?vue&type=template&id=16f097b4&scoped=true&"
import script from "./card5.vue?vue&type=script&lang=js&"
export * from "./card5.vue?vue&type=script&lang=js&"
import style0 from "./card5.vue?vue&type=style&index=0&id=16f097b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f097b4",
  null
  
)

export default component.exports